import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SellSheetPagination from 'containers/SellSheet/SellSheetPagination';
import React, { useState } from 'react';
import ButtonCSCLed from 'shared/Button/ButtonCSCLed';
import { config } from 'utils/Constance';

type RewardsReceiptViewModel = {
  receiptNumber: string;
  dateUploaded: string;
  status: string;
  totalPointValue: string;
  uploadReceiptsPath: string;
};

type ProofOfPurchaseProps = {
  rewardsData: RewardsReceiptViewModel[];
};

const getStatusStyles = (status: string) => {
    switch (status) {
      case 'Approved':
        return 'bg-green-200 text-green-800';
      case 'Pending':
        return 'bg-yellow-200 text-yellow-800';
      default:
        return 'bg-gray-200 text-black';
    }
  };

const ProofOfPurchaseTable: React.FC<ProofOfPurchaseProps> = ({ rewardsData }) => {
  const total = rewardsData.reduce((sum, item) => {
    const value = Number(item.totalPointValue);
    return isNaN(value) ? sum : sum + value;
  }, 0);

   const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = rewardsData?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };


   const handleRewardsURL = (url : string) =>{
     if (url?.trim()) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
   };

   const renderMain = () => {
    return (
      <>
        {/* Desktop Table View */}
        <table className="w-full -mt-4 hidden md:table" style={{ fontFamily: 'Poppins, sans-serif' }}>
          <thead>
            <tr className="text-sm text-center text-black border-b border-gray-200">
              <th className="pb-2 py-4">POP No.</th>
              <th className="pb-2 py-4">Date Uploaded</th>
              <th className="pb-2 py-4">Review Status</th>
              <th className="pb-2 py-4">Total Point Value</th>
              <th className="pb-2 py-4">View Upload</th>
            </tr>
          </thead>
          <tbody>
             {currentItems.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center text-black">
                  <div className="flex justify-center items-center mt-4">
                    Upload a proof of purchase to collect reward points. Once submitted, it will show up here.
                  </div>
                </td>
              </tr>
             ) : (
              currentItems.map((item, index) => (
                <tr key={index} className="border-b text-center border-gray-200">
                  <td className="py-4">{item.receiptNumber}</td>
                  <td className="py-4">{item.dateUploaded}</td>
                  <td className="py-4">
                    <span className={`${getStatusStyles(item.status)} text-xs font-semibold px-3 py-1 rounded-full`}>
                      {item.status}
                    </span>
                  </td>
                  <td className="py-4">{item.totalPointValue}</td>
                  <td className="py-4">
                    <ButtonCSCLed
                      onClick={() => handleRewardsURL(`${config.url.AWS_S3_URL}${item.uploadReceiptsPath}`)}
                    >
                      <FontAwesomeIcon icon={faFolderOpen} size="sm" />
                    </ButtonCSCLed>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
  
        {/* Mobile Card View */}
        <div className="sm:hidden space-y-4">
          {currentItems.length === 0 ? (
            <dl className="p-4 rounded-md shadow-md">
              <div className="flex justify-center text-center items-center">
                Upload a proof of purchase to collect reward points. Once submitted, it will show up here.
              </div>
            </dl>
          ) : currentItems.map((item, index) => (
            <dl key={index} className="p-4 bg-white rounded-md shadow-md">
              <div className="flex justify-between items-center mb-2">
                <dt className="font-bold text-sm text-black">POP No.</dt>
                <dd className="text-sm text-gray-900">{item.receiptNumber}</dd>
              </div>
              <div className="flex justify-between items-center mb-2">
                <dt className="font-bold text-sm text-black">Date Uploaded</dt>
                <dd className="text-sm text-gray-900">{item.dateUploaded}</dd>
              </div>
              <div className="flex justify-between items-center mb-2">
                <dt className="font-bold text-sm text-black">Status</dt>
                <dd>
                  <span className={`${getStatusStyles(item.status)} text-xs font-bold px-2 py-1 rounded-full`}>
                    {item.status}
                  </span>
                </dd>
              </div>
              <div className="flex justify-between items-center mb-2">
                <dt className="font-bold text-sm text-black">Points</dt>
                <dd className="text-sm text-gray-900">{item.totalPointValue}</dd>
              </div>
              <div className="mt-4 text-left sm:mt-2 sm:text-right">
                <ButtonCSCLed onClick={() => handleRewardsURL(`${config.url.AWS_S3_URL}${item.uploadReceiptsPath}`)}>
                  View your upload
                </ButtonCSCLed>
              </div>
            </dl>
          ))}
       </div>
      </>
    );
  };
  //  const renderMain = () => {
  //     return(
  //       <table className="w-full -mt-4" style={{fontFamily: 'Poppins, sans-serif'}}>
  //       <thead>
  //         <tr className="text-sm text-center text-black border-b border-gray-200">
  //           <th className="pb-2 py-4">POP No.</th>
  //           <th className="pb-2 py-4">Date Uploaded</th>
  //           <th className="pb-2 py-4">Review Status</th>
  //           <th className="pb-2 py-4">Total Point Value</th>
  //           <th className="pb-2 py-4">View Upload</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //       {currentItems.map((item, index) => (
  //         <tr key={index} className="border-b text-center border-gray-200" style={{fontFamily: 'Poppins, sans-serif'}}>
  //               <td className="py-4">{item.receiptNumber}</td>
  //               <td className="py-4">{item.dateUploaded}</td>
  //               <td className="py-4">
  //                 <span className={`${getStatusStyles(item.status)} text-xs font-semibold px-3 py-1 rounded-full`}>
  //                     {item.status}
  //                 </span>
  //               </td>
  //               <td className="py-4">{item.totalPointValue}</td>
  //               <td className="py-4">
  //                 <ButtonCSCLed
  //                   onClick={()=>handleRewardsURL(`${config.url.AWS_S3_URL}${item.uploadReceiptsPath}`)}
  //                 >  <FontAwesomeIcon icon={faFolderOpen} size="sm" />
  //                 </ButtonCSCLed>
  //               </td>
  //         </tr>
  //       ))}
  //       </tbody>
  //       {/* <tfoot className="text-sm text-right text-black" style={{fontFamily: 'Poppins, sans-serif'}}>
  //         <tr>
  //           <td colSpan={4} className="text-right pt-4"></td>
  //           <td className="text-right pt-4"></td>
  //         </tr>
  //         <tr className="text-black font-semibold text-base">
  //           <td colSpan={4} className="text-right pt-4">Total</td>
  //           <td className="text-center pt-4">{total}</td>
  //         </tr>
  //         <tr>
  //           <td colSpan={4} className="text-right pt-4"></td>
  //           <td className="text-right pt-4"></td>
  //         </tr>
  //       </tfoot> */}
  //       </table>
  //     )
  //  };

  return (
    <main className='rounded-lg sm:rounded-lg xl:rounded-[40px] z-0 bg-neutral-50/70 dark:bg-black/20'>
       {/* <div className='w-full'>
       <h2
        className="font-medium text-center sm:text-left text-xl text-gray-800 halloween:text-black halloween:border-white sm:text-3xl md:text-2xl pb-1 sm:pb-6"
        style={{ fontFamily: 'Poppins, sans-serif', paddingTop: '2.25rem', paddingLeft: '2.5rem' }}
      >
        Your Submitted Proof of Purchases
      </h2>
      </div> */}
    <div className='flex justify-center sm:justify-start'>
        <h2
        className="text-center sm:text-left font-medium text-xl text-gray-800 halloween:text-black halloween:border-white sm:text-3xl md:text-2xl pb-1 sm:pb-6 pt-9 px-4 sm:px-10"
        style={{ fontFamily: 'Poppins, sans-serif' }}
        >
        Your Submitted Proof of Purchases
        </h2>
    </div>

      <div className="max-w-8xl mx-auto p-6" style={{fontFamily: 'Poppins, sans-serif'}}>
        <div className="overflow-x-auto">
          {renderMain()}

            {rewardsData.length > itemsPerPage && (
               <div className="mt-4 sm:mt-3"> 
                <SellSheetPagination
                  className="py-3 pr-3 sm:pr-0"
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  totalItems={rewardsData?.length as number}
                  onPageChange={handlePageChange}
                />
               </div>
            )}
        </div>
       </div>
    </main>
   
  );
};

export default ProofOfPurchaseTable;
